// removed by extract-text-webpack-plugin
module.exports = {"container":"_3zvbBEqM7VDXuVmgHKrVMX"};